import React from 'react';
import DeleteButton from '../components/DeleteButton';

export const deleteActionCellFormatter = onClick => (_, { rowData }) => {
  const { canDelete } = rowData;

  return <DeleteButton active={canDelete} onClick={() => onClick(rowData)} />;
};



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/common/table/formatters/deleteActionCellFormatter.js